// 提现状态枚举
export const dealStatusList = [
  {
    value: 0,
    label: '处理中'
  },
  {
    value: 1,
    label: '处理成功'
  },
  {
    value: -1,
    label: '处理失败'
  }
]

// 费用类型枚举
export const expenseTypeList = [
  { value: 1, label: '旧机费用' },
  {
    value: 2,
    label: '推荐费用'
  }
]

// 请求类型映射
export const requestTypeMap = {
  1: '冻结',
  2: '提现'
}

// 处理状态映射
export const dealStatusMap = {
  '0': '处理中',
  '1': '处理成功',
  '-1': '处理失败'
}

// 订单状态映射
export const orderStateMap = {
  '-1': '待派单',
  '0': '待预约',
  '1': '待取件',
  '101': '已取件',
  '102': '待提现',
  '103': '提现中',
  '2': '已完成',
  '3': '已取消',
  '4': '已估价'
}

// 费用类型映射
export const expenseTypeMap = {
  1: '旧机费用',
  2: '推荐费用'
}

// 旧机品类
export const oldMachineCategoryMap = {
    '101': '家用空调',
    '102': '电视机',
    '103': '热水器',
    '104': '电脑',
    '106': '冰箱',
    '109': '壁挂炉',
    '115': '厨大电',
    '117': '洗衣机',
}

export const orderStatusMap = {
  '1': '待补充收款信息',
  '2': '支付中',
  '3': '支付成功',
  '4': '支付失败',
  '5': '支付异常',
  '6': '对账异常',
}


// WEBPACK FOOTER //
// ./src/views/paymentManagement/paymentEnums.js